<template>
  <CCard class="mob-pd-0px">
    <CCardHeader class="grey-header d-flex mob-flex-column ai-center">
      <CRow class="flex-flow-column">
        <CCol>
          <strong>{{ $t("fareView.title") }}</strong>
        </CCol>

        <p class="desc">{{ $t("fareView.desc") }}</p>
      </CRow>
    </CCardHeader>

    <div v-if="search!=null" class="center-content">
      <br />

      <div class="d-flex" v-if="GET_SELECTED_CONTRACT&&GET_SELECTED_CONTRACT.contractcode">
        <h3>{{$t("contract.contractName")+' : '}}</h3>
        <h3
          class="text-transform-uppercase"
        >{{GET_SELECTED_CONTRACT&&GET_SELECTED_CONTRACT.contractcode}}</h3>
      </div>
      <br />

      <div class="flight-search-wrapper" @click="isPaxViewOpen=false">
        <div class="search-option">
          <cRadioButton
            v-for="tripObj in jTypeTabs"
            :key="'trip'+tripObj.code"
            :name="tripObj.code"
            :value="tripObj.code"
            :label="tripObj.name"
            v-on:input="onChangeTripCategory(tripObj)"
            rules="required"
            :selValue="jTypeTabs[search.trip-1]"
          />
        </div>

        <div class="main-search">
          <div class="route-name-wrapper">
            <div class="place">
              <div class="form">
                <label class="typo__label">{{$t('fareView.from')}}</label>
                <multiselect
                  :allow-empty="false"
                  :showLabels="false"
                  :clearOnSelect="false"
                  v-model="search.route[0].from"
                  :options="lsCountryRoute"
                  :multiple="false"
                  group-values="routeList"
                  group-label="country"
                  :group-select="false"
                  :placeholder="$t('fareView.searchPlaceHolder')"
                  track-by="depcode"
                  v-on:input="getArrivalRoutes"
                  v-on:open="addCssClass()"
                  ref="fromCityPicker"
                  :searchable="true"
                  :custom-label="cityPickCustomeLabel"
                  @search-change="addCssClass()"
                >
                  <template
                    slot="singleLabel"
                    slot-scope="{ option }"
                  >{{ option.depcode.city}} ({{option.depcode.airportcode}})</template>
                  <template slot="option" slot-scope="props">
                    <div>
                      <span v-if="props.option.$isLabel">{{ props.option.$groupLabel.value }}</span>
                      <span v-else>
                        {{ props.option.depcode.city}}
                        <strong
                          v-if="props.option.depcode"
                          class="right"
                        >{{ props.option.depcode.airportcode }}</strong>
                      </span>
                    </div>
                  </template>
                  <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                </multiselect>
              </div>
              <div class="center-icon" @click="rotate()">
                <img src="@imgPath/img/png/flight.png" alt />
                <img
                  src="@imgPath/img/png/flight-round.png"
                  alt
                  id="rotate-icon"
                  :class="{'re_rotate' : isFlIconRotate}"
                />
              </div>
              <div class="to">
                <label class="typo__label">{{$t('fareView.to')}}</label>
                <multiselect
                  :allow-empty="false"
                  :showLabels="false"
                  :clearOnSelect="false"
                  v-model="search.route[0].to"
                  :options="lsArrival"
                  :multiple="false"
                  group-values="routeList"
                  group-label="country"
                  :group-select="false"
                  :placeholder="$t('fareView.searchPlaceHolder')"
                  track-by="depcode"
                  v-on:input="assignArrToSearch(search.route[0].to)"
                  ref="toCityPicker"
                  :searchable="true"
                  :custom-label="cityPickCustomeLabel"
                  @search-change="addCssClass()"
                >
                  <template
                    slot="singleLabel"
                    slot-scope="{ option }"
                  >{{ option.depcode.city}} ({{option.depcode.airportcode}})</template>
                  <template slot="option" slot-scope="props">
                    <div>
                      <span v-if="props.option.$isLabel">{{ props.option.$groupLabel.value }}</span>
                      <span v-else>
                        {{ props.option.depcode.city}}
                        <strong
                          v-if="props.option.depcode"
                          class="right"
                        >{{ props.option.depcode.airportcode }}</strong>
                      </span>
                    </div>
                  </template>
                  <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                  <span slot="noOptions">{{$t('fareView.selectDeparture')}}</span>
                </multiselect>
              </div>
            </div>
            <div class="date" :class="{'oneway' : search.trip!=jTypeTabs[1].code}">
              <label class="typo__label depart">{{$t('fareView.journeyDate')}}</label>
              <label
                class="typo__label return"
                v-if="search.trip==jTypeTabs[1].code"
              >{{$t('fareView.return')}}</label>

              <HotelDatePicker
                v-if="isDatePicShow"
                :showYear="true"
                :startingDateValue="search.trip==jTypeTabs[1].code?new Date(search.route[0].date):null"
                :endingDateValue="search.trip==jTypeTabs[1].code?new Date(search.route[1].date):null"
                :hoveringTooltip="false"
                :displayClearButton="false"
                format="dddd, MMM DD"
                @check-in-changed="getFromDate"
                @check-out-changed="getToDate"
                :singleDaySelection="search.trip==jTypeTabs[1].code?false:true"
                :i18n="assigni18nObjByLang(search.route[0].date,search.trip==jTypeTabs[1].code?search.route[1].date:'')"
                ref="flightDatePicker"
                :minNights="0"
                :enableCheckout="search.trip==jTypeTabs[1].code?
                true:false"
              />
            </div>
          </div>

          <div class="currency place" id="currency">
            <cOrgCurrencyDp
              v-if="GET_ORG_CURRENCY_RES"
              v-on:input="onCurrencyChange"
              :selValue="search.currency"
              :label="$t('fareView.currName')"
              :ctrlCode="'id'"
              :isAllowEmpty="false"
              :isShowCode="true"
              :isMultiple="false"
              :isSearchable="false"
              :url="getOrgCurrencyServiceURL()"
              rules="required"
              :defaultCurrency="defaultCurrencyCode"
            />
          </div>
          <div class="date" :class="{'oneway' :true}">
            <label class="typo__label depart">{{$t('fareView.bookingDate')}}</label>
            <!-- :endDate="new Date()" -->
            <HotelDatePicker
              v-if="isBookingDatePicShow"
              id="bookingflightDatePicker"
              ref="bookingflightDatePicker"
              :showYear="true"
              :endDate="new Date(search.route[0].date)"
              :hoveringTooltip="false"
              :displayClearButton="false"
              format="dddd, MMM DD"
              @check-in-changed="getBookingFromDate"
              :singleDaySelection="true"
              :i18n="assigni18nObjByLang(search.bookingDate)"
              :minNights="0"
            />
            <!-- :enableCheckout="search.trip==jTypeTabs[1].code?
            true:false"-->
          </div>

          <div @click="emitSearchObj" class="search-btn">
            <span class="dot"></span>
            <span>{{$t('fareView.searchBtn')}}</span>
          </div>
        </div>
      </div>
      <!-- <div
        :show="alertValue!=null"
        v-if="alertValue==$t("fareView.routeInvalid")"
        class="search_error_message"
      >{{alertValue}}</div> -->
    </div>
    <div
      class="m-auto"
      v-if="fareViewList && fareViewList.obflights.length==0 && fareViewList.ibflights.length==0"
    >
      <br />
      <br />
      <h4>There are no flights for the above routes</h4>
      <br />
      <br />
    </div>
    <CCard v-else-if="isSearched && tabSearchObj ">
      <CCardBody class="container">
        <div class="row">
          <div class="col-sm">
            <span></span>
          </div>

          <div
            v-if="tabSearchObj.route[0]"
            class="col-sm"
            @click="activeTabIndex=0,flights=null"
            :class="activeTabIndex==0?'active':''"
           >
            <span>{{tabSearchObj.route[0].from.depcode.airportcode+' - '}}</span>
            <span>{{tabSearchObj.route[0].to.depcode.airportcode}}</span>
          </div>
          <div
            v-if="tabSearchObj.route[1]"
            class="col-sm"
            @click="activeTabIndex=1,flights=null"
            :class="activeTabIndex==1?'active':''"
           >
            <span>{{tabSearchObj.route[1].from.depcode.airportcode+' - '}}</span>
            <span>{{tabSearchObj.route[1].to.depcode.airportcode}}</span>
          </div>
        </div>
        <br />
        <div v-if="activeTabIndex==0  && fareViewList && fareViewList.obflights!=null">
          <div
            v-for="(flightObj,obindex) in fareViewList.obflights"
            :key="'obviewLs'+obindex"
           class="row"
            :class="flightObj && flightObj[0] && flightObj[0][0] && flightObj[0][0].hasOwnProperty('isSearchedDate')?'active':''"
           >
            <div v-if="flightObj && flightObj[0]&& flightObj[0][0] && flightObj[0][0].obFlight" class="col-sm">
              <span v-if="!flightObj[0][0].obFlight[0].flight.FlightNo">
                {{flightObj[0][0].pricegroup_code|formatDate(DATE_TIME_FORMAT.DEFAULT_DATE_FORMAT)}}
                </span>
              {{flightObj[0][0].obFlight[0].flight.DepDate|formatDate(DATE_TIME_FORMAT.DEFAULT_DATE_FORMAT)}}
              <CRow class="time-place-wrap">
                <CCol class="left">
                  <div class="time">
                    {{flightObj[0][0] && flightObj[0][0].obFlight[0] &&
                    flightObj[0][0].obFlight[0].flight.DepDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}
                  </div>
                  <div class="place-code">
                    {{flightObj[0][0] &&
                    flightObj[0][0].obFlight[0] &&
                    flightObj[0][0].obFlight[0].flight.DepAirport}}
                  </div>
                </CCol>
                <CCol class="center">
                  <div>
                    {{flightObj[0][0] && flightObj[0][0].obFlight[0] 
                    && flightObj[0][0].obFlight[0].flight.TotalDuration|
                    convertToHrMin("minutes","H [h] mm [m]")}}
                  </div>
                  <div>
                  <img v-if="flightObj[0][0] && flightObj[0][0].obFlight[0] && 
                  flightObj[0][0].obFlight[0].flight.FlightNo" src="@imgPath/img/svg/icons/flying-flight.svg" alt />
                  </div>
                  <div>{{flightObj[0][0] && flightObj[0][0].obFlight[0] && flightObj[0][0].obFlight[0].flight.FlightNo}}</div>
                  <div  v-if="flightObj[0][0] && flightObj[0][0].obFlight[0].flight.FlightNo">{{$t('fareView.availSeats')+' '}}: {{flightObj[0][0].freeSeats ? flightObj[0][0].freeSeats : 0}}</div>
                </CCol>

                <CCol class="right">
                  <div class="time">
                    {{flightObj[0][0] && flightObj[0][0].obFlight[flightObj[0][0].obFlight.length-1] &&
                    flightObj[0][0].obFlight[flightObj[0][0].obFlight.length-1].flight.ArrDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}
                  </div>
                  <div class="place-code">
                    {{flightObj[0][0].obFlight && flightObj[0][0].obFlight[flightObj[0][0].obFlight.length-1] &&
                    flightObj[0][0].obFlight[flightObj[0][0].obFlight.length-1].flight.ArrAirport}}
                  </div>
                </CCol>
              </CRow>
              <br />
            </div>
          <div
              v-for="(bookclass,bindex) in obBookingClass"
              :key="'classo'+bindex"
              class="col-sm mt-auto"
            >
          <div
            v-for="(flights,obLsindex) in flightObj"
            :key="'obLs'+obLsindex"
            class="col-sm mt-auto"
            
            >
            <CCard v-if=" bookclass == flights[0].obFlight[0].flight.Bookingclass" 
             @click.stop="toggleModal(flights,true)"
                
               >
                <div v-if="flights[0].obFlight && flights[0].obFlight[0].flight.Bookingclass!='' && 
                  flights[0].obFlight[0].flight.FlightNo">
                  <div>{{ flights[0].obFlight[0].flight.Bookingclass}}</div>
                  <br />
                </div>
              <div
                  v-if="flights[0].obFlight && flights[0].obFlight[0].flight.Bookingclass!='' && 
                  flights[0].obFlight[0].flight.FlightNo"
                >{{flights[0].obFlight[0].flight.qty==null?0+' Seat':flights[0].obFlight[0].flight.qty+' Seats'}}
              </div>
                
            <div
              v-for="(flightLs,cindex) in flights"
              :key="'flightobj'+cindex"
             >
             <div v-if="bookclass == flights[0].obFlight[0].flight.Bookingclass">
                <span
                  v-if="flightLs.Pricing && flightLs.Pricing.TotalAmount && flightLs.Pricing.Currency"
                 >
                  {{flightLs.Pricing.Currency}}
                  {{flightLs.Pricing.TotalAmount | formatNumber(flightLs.Pricing.Currency)}}
                  <br />
                </span>
                <span v-if="flightLs.error && flightLs.error[0]" class="error">
                  {{flightLs.error[0]}}
                  <br />
                </span>
                <span
                  v-if="flightLs.Pricing && flightLs.Pricing.invalidFares && flightLs.Pricing.invalidFares[0]"
                  class="error"
                 >
                  {{flightLs.Pricing.invalidFares[0].error}}
                  <br />
                </span>
                <span
                  v-if="flightLs.Pricing && flightLs.Pricing.invalidPrices && flightLs.Pricing.invalidPrices[0]"
                  class="error"
                 >
                  {{flightLs.Pricing.invalidPrices[0].errors.toString()}}
                  <br />
                </span>
              </div>
              
            </div>
          </CCard>
           
          <!-- </div> -->
          
        </div>  
        </div>
        <div v-if="obBookingClass.length==0">
             <div
              v-for="(flights,cindex) in flightObj[0]"
              :key="'classo'+cindex"
              class="col-sm mt-auto"
             >
              <div
              v-for="(flightLs,cindex) in flights"
              :key="'flightobj'+cindex"
             >
             <div >
                <span
                  v-if="flightLs.Pricing && flightLs.Pricing.TotalAmount && flightLs.Pricing.Currency"
                 >
                  {{flightLs.Pricing.Currency}}
                  {{flightLs.Pricing.TotalAmount | formatNumber(flightLs.Pricing.Currency)}}
                  <br />
                </span>
                <span v-if="flightLs.error && flightLs.error[0]" class="error">
                  {{flightLs.error[0]}}
                  <br />
                </span>
                <span
                  v-if="flightLs.Pricing && flightLs.Pricing.invalidFares && flightLs.Pricing.invalidFares[0]"
                  class="error"
                 >
                  {{flightLs.Pricing.invalidFares[0].error}}
                  <br />
                </span>
                <span
                  v-if="flightLs.Pricing && flightLs.Pricing.invalidPrices && flightLs.Pricing.invalidPrices[0]"
                  class="error"
                 >
                  {{flightLs.Pricing.invalidPrices[0].errors.toString()}}
                  <br />
                </span>
              </div>
              
            </div>
             </div>
           </div>
            
        </div>
        <div v-if="isLoading" class="row loader">
                <div class="col-sm loadercol"></div>
              </div>
        <div v-if="flights!=null?( (flights[0].error ?(flights[0].error?flights[0].error==0:false) : true)):false ">
          <CModal
                
                :show.sync="flights[0].obFlight[0].flight.showPaxPrice"
                :backdrop="true"
                :closeOnBackdrop="true"
                :centered="true"
                :size="'lg'"
                >
                <template #header-wrapper>
                  <div class="title"> 
                  <div class="d-flex justify-content-center">
                    <template>
                     
                      <CCardHeader>
                        <CRow>
                          <CCol
                            v-if="flights[0].obFlight[0].flight.Bookingclass!=''"
                            class="title-icon"
                          >
                            <strong>{{'Class '+flights[0].obFlight[0].flight.Bookingclass}}</strong>
                          </CCol>
                        </CRow>
                        
                      </CCardHeader>
                      
                    </template>
                    <br />
                    <br />
                  </div>
                  <div @click="flights[0].obFlight[0].flight.showPaxPrice=false" class="right">
                            <img class="close" src="@imgPath/img/svg/icons/cross.svg" alt width="20px">
                  </div>
                  </div>
                </template>
                <div  v-for="(flight, flightindex) in flights"
                    :key="flightindex+'flight'">
                <div
                  v-if="flight.Pricing && flight.Pricing.invalidFares && flight.Pricing.invalidFares.length!=0"
                  class="d-flex justify-content-center alert-msg"
                 >
                  <div
                    v-for="(fares, findex) in flight.Pricing.invalidFares"
                    :key="findex+'invalidfare'"
                  >{{fares.error}}</div>
                </div>

                <div
                  v-if="flight.Pricing && flight.Pricing.invalidPrices && flight.Pricing.invalidPrices.length!=0"
                  class="d-flex justify-content-center alert-msg"
                 >
                  <div
                    v-for="(prices, pindex) in flight.Pricing.invalidPrices"
                    :key="pindex+'invalidprice'"
                  >{{prices.errors.toString()}}</div>
                </div>

                <div v-if="flight.clientPricing" class="d-flex justify-content-center alert-msg">
                  <CRow>
                    <CCol>Adult</CCol>
                    <CCol>
                      <div>Basefare {{' '+flight.clientPricing.AdultPrice.BaseFare| formatNumber(flight.Pricing.Currency)}}</div>
                      <div>Tax {{' '+flight.clientPricing.AdultPrice.Tax| formatNumber(flight.Pricing.Currency)}}</div>
                      <hr />
                      <div>Total {{' '+flight.clientPricing.AdultPrice.Total| formatNumber(flight.Pricing.Currency)}}</div>
                    </CCol>
                  </CRow>
                  <br />
                  <CRow>
                    <CCol>Child</CCol>
                    <CCol>
                      <div>Basefare {{' '+flight.clientPricing.ChildPrice.BaseFare| formatNumber(flight.Pricing.Currency)}}</div>
                      <div>Tax {{' '+flight.clientPricing.ChildPrice.Tax| formatNumber(flight.Pricing.Currency)}}</div>
                      <hr />
                      <div>Total {{' '+flight.clientPricing.ChildPrice.Total| formatNumber(flight.Pricing.Currency)}}</div>
                    </CCol>
                  </CRow>
                  <br />
                  <CRow>
                    <CCol>Infant</CCol>
                    <CCol>
                      <div>Basefare {{' '+flight.clientPricing.InfantPrice.BaseFare| formatNumber(flight.Pricing.Currency)}}</div>
                      <div>Tax {{' '+flight.clientPricing.InfantPrice.Tax| formatNumber(flight.Pricing.Currency)}}</div>
                      <hr />
                      <div>Total {{' '+flight.clientPricing.InfantPrice.Total| formatNumber(flight.Pricing.Currency)}}</div>
                    </CCol>
                  </CRow>
                </div>
                </div>
                <br />
                <template #footer-wrapper>
                  <span></span>
                </template>
        </CModal>
        </div>
        </div>
        <div v-if="activeTabIndex==1 && fareViewList">
          <div
            v-for="(flightObj,ibindex) in fareViewList.ibflights"
            :key="'ibviewLs'+ibindex"
            class="row"
            :class="flightObj && flightObj[0][0] && flightObj[0][0].hasOwnProperty('isSearchedDate')?'active':''"
          >
            <div v-if="flightObj && flightObj[0][0] && flightObj[0][0].ibFlight" class="col-sm">
              <span v-if="!flightObj[0][0].ibFlight[0].flight.FlightNo">
                {{flightObj[0][0].pricegroup_code|formatDate(DATE_TIME_FORMAT.DEFAULT_DATE_FORMAT)}}
                </span>
              {{flightObj[0][0].ibFlight[0].flight.DepDate|formatDate(DATE_TIME_FORMAT.DEFAULT_DATE_FORMAT)}}
              <CRow class="time-place-wrap">
                <CCol class="left">
                  <div class="time">
                    {{flightObj[0][0] && flightObj[0][0].ibFlight[0] &&
                    flightObj[0][0].ibFlight[0].flight.DepDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}
                  </div>
                  <div class="place-code">
                    {{flightObj[0][0] &&
                    flightObj[0][0].ibFlight[0] &&
                    flightObj[0][0].ibFlight[0].flight.DepAirport}}
                  </div>
                </CCol>
                <CCol class="center">
                  <div>
                    {{flightObj[0][0] && flightObj[0][0].ibFlight[0] && flightObj[0][0].ibFlight[0].flight.TotalDuration|
                    convertToHrMin("minutes","H [h] mm [m]")}}
                  </div>
                  <div>
                  <img v-if="flightObj[0][0] && flightObj[0][0].ibFlight[0] && flightObj[0][0].ibFlight[0].flight.FlightNo" src="@imgPath/img/svg/icons/flying-flight.svg" alt />
                  </div>
                  <div>{{flightObj[0][0] && flightObj[0][0].ibFlight[0] && flightObj[0][0].ibFlight[0].flight.FlightNo}}</div>
                  <div v-if="flightObj[0][0] && flightObj[0][0].ibFlight[0] && flightObj[0][0].ibFlight[0].flight.FlightNo">
                    {{$t('fareView.availSeats')+' '}}: {{flightObj[0][0].freeSeats ? flightObj[0][0].freeSeats : 0}}
                  </div>
                </CCol>

                <CCol class="right">
                  <div class="time">
                    {{flightObj[0][0] && flightObj[0][0].ibFlight[flightObj[0][0].ibFlight.length-1] &&
                    flightObj[0][0].ibFlight[flightObj[0][0].ibFlight.length-1].flight.ArrDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}
                  </div>
                  <div class="place-code">
                    {{flightObj[0][0].ibFlight && flightObj[0][0].ibFlight[flightObj[0][0].ibFlight.length-1] &&
                    flightObj[0][0].ibFlight[flightObj[0][0].ibFlight.length-1].flight.ArrAirport}}
                  </div>
                </CCol>
              </CRow>
              <br />
            </div>
            <!-- <div
              v-else
              class="col-sm"
            >{{flightObj[0].pricegroup_code|formatDate(DATE_TIME_FORMAT.DEFAULT_DATE_FORMAT)}}</div> -->
               <!-- <div v-if="ibBookingClass.length>0"> -->
          
          <div
              v-for="(bookclass,bindex) in ibBookingClass"
              :key="'ibclasso'+bindex"
              class="col-sm mt-auto"
            >
            <div
              v-for="(flights,cindex) in flightObj"
              :key="'ibclassoflights'+cindex"
              class="col-sm mt-auto"
              >
              
              
            <CCard v-if="bookclass==flights[0].ibFlight[0].flight.Bookingclass" @click="toggleModal(flights,false)"
                >
                <span v-if="flights[0].ibFlight[0].flight.FlightNo && flights[0].ibFlight[0].flight.Bookingclass!=''">
                {{flights[0].ibFlight && flights[0].ibFlight[0].flight.Bookingclass?flights[0].ibFlight[0].flight.Bookingclass:''}}
                 </span>
                <div v-if="flights[0].ibFlight && flights[0].ibFlight[0].flight.Bookingclass!='' && flights[0].ibFlight[0].flight.FlightNo">
                  {{flights[0].ibFlight[0].flight.qty==null?0+' Seat':flights[0].ibFlight[0].flight.qty+' Seats'}}
                  <br />
                </div>

            <div
              v-for="(flightLs,cindex) in flights"
              :key="'flightobj'+cindex"
             >
             <div v-if="bookclass == flights[0].ibFlight[0].flight.Bookingclass">
                <span
                  v-if="flightLs.Pricing && flightLs.Pricing.TotalAmount && flightLs.Pricing.Currency"
                 >
                  {{flightLs.Pricing.Currency}}
                  {{flightLs.Pricing.TotalAmount | formatNumber(flightLs.Pricing.Currency)}}
                  <br />
                </span>
                <span
                  v-if="flightLs.Pricing && flightLs.Pricing.invalidFares && flightLs.Pricing.invalidFares[0]"
                  class="error"
                 >
                  {{flightLs.Pricing.invalidFares[0].error}}
                  <br />
                </span>
                <span v-if="flightLs.error && flightLs.error[0]" class="error">
                  {{flightLs.error[0]}}
                  <br />
                </span>
                <span
                  v-if="flightLs.Pricing && flightLs.Pricing.invalidPrices && flightLs.Pricing.invalidPrices[0]"
                  class="error"
                 >
                  {{flightLs.Pricing.invalidPrices[0].errors.toString()}}
                  <br />
                </span>
             </div>
            </div>
            </CCard>
              <!-- <div v-if="flights.Pricing && flights.Pricing.invalidFares && flights.Pricing.invalidPrices&&
                    flights.Pricing.invalidFares.length==0 && flights.Pricing.invalidPrices.length==0"
                >
                  <span>No flights on this date</span>
                
              
              </div>   -->
            </div>
            </div>
            <div v-if="ibBookingClass.length==0">
             <div
              v-for="(flights,cindex) in flightObj"
              :key="'noibclass'+cindex"
              class="col-sm mt-auto"
               >
               <div
              v-for="(flightLs,cindex) in flights"
              :key="'noibclassFlights'+cindex"
             >
             <div >
                <span
                  v-if="flightLs.Pricing && flightLs.Pricing.TotalAmount && flightLs.Pricing.Currency"
                 >
                  {{flightLs.Pricing.Currency}}
                  {{flightLs.Pricing.TotalAmount | formatNumber(flightLs.Pricing.Currency)}}
                  <br />
                </span>
                <span
                  v-if="flightLs.Pricing && flightLs.Pricing.invalidFares && flightLs.Pricing.invalidFares[0]"
                  class="error"
                 >
                  {{flightLs.Pricing.invalidFares[0].error}}
                  <br />
                </span>
                <span v-if="flightLs.error && flightLs.error[0]" class="error">
                  {{flightLs.error[0]}}
                  <br />
                </span>
                <span
                  v-if="flightLs.Pricing && flightLs.Pricing.invalidPrices && flightLs.Pricing.invalidPrices[0]"
                  class="error"
                 >
                  {{flightLs.Pricing.invalidPrices[0].errors.toString()}}
                  <br />
                </span>
             </div>
            </div>
             </div>
           </div>
         
              
               
              </div>
          <div v-if="isLoading" class="row loader">
                <div class="col-sm loadercol"></div>
              </div>
          <div v-if="flights!=null?( (flights[0].error ?(flights[0].error?flights[0].error==0:false) : true)):false ">
          <CModal
               :show.sync="flights[0].ibFlight[0].flight.showPaxPrice"
                :backdrop="true"
                :closeOnBackdrop="true"
                :centered="true"
                :size="'lg'"
                >
                <template #header-wrapper>
                  <div class="d-flex justify-content-center">
                    <template>
                      <CCardHeader>
                        <CRow>
                          <CCol v-if="flights[0].ibFlight[0].flight.Bookingclass" class="title-icon">
                            <strong>{{'Class '+flights[0].ibFlight[0].flight.Bookingclass}}</strong>
                          </CCol>
                        </CRow>
                       
                      </CCardHeader>
                    </template>
                    <br />
                    <br />
                  </div>
                  <div @click="flights[0].ibFlight[0].flight.showPaxPrice=false" class="right">
                            <img class="close" src="@imgPath/img/svg/icons/cross.svg" alt width="20px">
                  </div>
                </template> 
              <div  v-for="(flight, flightindex) in flights"
                    :key="flightindex+'flight'">
                <div
                  v-if="flight.Pricing && flight.Pricing.invalidFares && flight.Pricing.invalidFares.length!=0"
                  class="d-flex justify-content-center alert-msg"
                 >
                  <div
                    v-for="(fares, findex) in flight.Pricing.invalidFares"
                    :key="findex+'invalidfare'"
                  >{{fares.error}}</div>
                </div>

                <div
                  v-if="flight.Pricing && flight.Pricing.invalidPrices && flight.Pricing.invalidPrices.length!=0"
                  class="d-flex justify-content-center alert-msg"
                 >
                  <div
                    v-for="(prices, pindex) in flight.Pricing.invalidPrices"
                    :key="pindex+'invalidprice'"
                  >{{prices.errors.toString()}}</div>
                </div>

                <div v-if="flight.clientPricing" class="d-flex justify-content-center alert-msg">
                  <CRow>
                    <CCol>Adult</CCol>
                    <CCol>
                      <div>Basefare {{' '+flight.clientPricing.AdultPrice.BaseFare| formatNumber(flight.Pricing.Currency)}}</div>
                      <div>Tax {{' '+flight.clientPricing.AdultPrice.Tax| formatNumber(flight.Pricing.Currency)}}</div>
                      <hr />
                      <div>Total {{' '+flight.clientPricing.AdultPrice.Total| formatNumber(flight.Pricing.Currency)}}</div>
                    </CCol>
                  </CRow>
                  <br />
                  <CRow>
                    <CCol>Child</CCol>
                    <CCol>
                      <div>Basefare {{' '+flight.clientPricing.ChildPrice.BaseFare| formatNumber(flight.Pricing.Currency)}}</div>
                      <div>Tax {{' '+flight.clientPricing.ChildPrice.Tax| formatNumber(flight.Pricing.Currency)}}</div>
                      <hr />
                      <div>Total {{' '+flight.clientPricing.ChildPrice.Total| formatNumber(flight.Pricing.Currency)}}</div>
                    </CCol>
                  </CRow>
                  <br />
                  <CRow>
                    <CCol>Infant</CCol>
                    <CCol>
                      <div>Basefare {{' '+flight.clientPricing.InfantPrice.BaseFare| formatNumber(flight.Pricing.Currency)}}</div>
                      <div>Tax {{' '+flight.clientPricing.InfantPrice.Tax| formatNumber(flight.Pricing.Currency)}}</div>
                      <hr />
                      <div>Total {{' '+flight.clientPricing.InfantPrice.Total| formatNumber(flight.Pricing.Currency)}}</div>
                    </CCol>
                  </CRow>
                </div>
              </div>
                <br />

                <template #footer-wrapper>
                  <span></span>
                </template>
        </CModal>
          </div>
        </div>
      </CCardBody>
    </CCard>
     <CAlert v-if="verboseInfo.length!=0 && isObflight && search.trip==1" show color="danger">
      <div v-if="verboseInfo.length!=0">
        <p v-for="(value, index) in verboseInfo" :key="index">{{ value }}</p>
      </div>
    </CAlert>
    <CAlert v-if="verboseInfo.length!=0 && search.trip==2 && isObflight && isIbflight" show color="danger">
      <div v-if="verboseInfo.length!=0">
        <p v-for="(value, index) in verboseInfo" :key="index">{{ value }}</p>
      </div>
    </CAlert>

    <CAlert v-if="alertValue" show color="danger">
      <div v-if="alertValue && alertValue.hasOwnProperty('valueList')">
        <p v-for="(value, index) in alertValue.valueList" :key="index">{{ value }}</p>
      </div>
      <div v-if="alertValue && alertValue.hasOwnProperty('codeList')">
        <span>{{ $t("cAlert.errorCode") + " : " }}</span>
        <span v-for="(code, index) in alertValue.codeList" :key="index">{{ code + " " }}</span>
      </div>
      <div v-if="alertValue && alertValue.constructor == String">
        <p>{{ alertValue }}</p>
      </div>
    </CAlert>
    <!-- <CCard v-else-if="isSearched&& fareViewList">
<strong>No Results</strong>
    </CCard>-->
  </CCard>
</template>

<script>
import Vue from "vue";
import { handleJWT, getErrorAlertValue } from "../../../util/util";

import {
  getFlightSearchHisFromLocal,
  setFlightSearchHisToLocal,
} from "./../../../applocalstorage/localStorage";
import VueNumberInput from "@chenfengyuan/vue-number-input";
import {
  dateFunctions,
  getDiffBtwDates,
  addDays,
  subDays,
  formatDate,
  isPastDate,
} from "../../../util/date/dateFunctions";
import cCurrencyDropDown from "../../../components/currency/cCurrencyDropDown";

import {
  TRIP,
  PAX,
  PAX_COUNT,
  LOCAL_STORAGE_KEYS,
  CITIZEN,
  TOAST_TYPE,
  ALL_CLIENT_CODE,
} from "../../../util/constants.js";
import cRadioButton from "../../../components/form/cRadioButton";
import cOrgCurrencyDp from "../../../components/currency/cOrgCurrencyDp";

import Logger from "../../../services/logger";
import apiGetRoutes from "../../../services/apiGetRoutes.js";
import apiCrsFareView from "../../../services/apiCrsFareView.js";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import router, {
  navigate,
  goBack,
  updateDataEdited,
} from "../../../router/index";

import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES,
} from "../../../config/API_DATA";
import {
  COMPONENT_NAME,
  PATHNAME,
  DATE_TIME_FORMAT,
} from "../../../util/constants";
import BaseConfiguration from "../../../config/base.js";
import SERVICE_URL from "../../../config/API_DATA";
import { i18n } from "../../../plugins/i18n.js";
import HotelDatePicker from "vue-range-datechooser";
import Multiselect from "vue-multiselect";
import {
  GroupByList,
  groupBy,
  cloneData,
  cloneDeep,
  addClassToBody,
  removeClassBody,
} from "../../../util/util.js";
import { mapGetters, mapActions } from "vuex";
import {Event} from "../../../main.js";
Vue.use(VueNumberInput);

export default {
  name: COMPONENT_NAME.FARE_VIEW,
  components: {
    // flightDatePicker,
    HotelDatePicker,
    Multiselect,
    cCurrencyDropDown,
    cOrgCurrencyDp,
    cRadioButton,
  },
  props: {
    searchObject: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    verboseInfo: [],
    isObflight: false,
    isIbflight: false,
    isBookingDatePicShow: true,
    isSearched: false,
    activeTabIndex: 0,
    isFlIconRotate: false,
    isDatePicShow: true,
    isLoading: true,
    lsCitizenCategory: [
      {
        name: i18n.tc("fareView.yes"),
        code: "Y",
      },
      {
        name: i18n.tc("fareView.no"),
        code: "N",
      },
    ],

    jTypeTabs: [
      {
        name: i18n.tc("fareView.oneWay"),
        code: TRIP.ONE_WAY,
      },
      {
        name: i18n.tc("fareView.roundTrip"),
        code: TRIP.ROUND_TRIP,
      },
    ],

    alertValue: null,
    lsCountryRoute: [],
    lsArrival: [],
    routesResponse: null,
    defaultCurrencyCode: null,
    fareViewList: null,
    alertValue: null,
    currentAlertCounter: 0,
    fareViewObj: null,
    obBookingClass: [],
    ibBookingClass: [],
    search: {
      trip: BaseConfiguration.defaultTrip,
      route: [
        {
          from: null,
          to: null,
          date: new Date(),
        },
      ],
      bookingDate: new Date(),

      currency: null,
    },
    tabSearchObj: null,
    active: false,
    flights: null
  }),

  methods: {
    ...mapActions("sFareView", {
      SET_ROUTES_OBJ: "SET_ROUTES_OBJ",
      SET_FAREVIEW_SEARCH_OBJ: "SET_FAREVIEW_SEARCH_OBJ",
      SET_ARR_LS: "SET_ARR_LS",
    }),

    ...mapActions("sCMultiCitySearch", {
      SET_ML_SEARCH_OBJ: "SET_ML_SEARCH_OBJ",
      // SET_IS_ML_SEARCH:"SET_IS_ML_SEARCH"
    }),

    //to focus departure dropdown
    openDatePicker() {
      if (BaseConfiguration.isDebug) console.log("openDatePicker");
      if (this.search.route[0].from && this.search.route[0].to) {
        this.$refs.bookingflightDatePicker.isOpen = true;
      }
    },

    onUpdateTabIndex() {
      try {
        if (BaseConfiguration.isDebug) console.log("onUpdateTabIndex");
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_VIEW,
          "error in onUpdateTabIndex",
          err.toString(),
          "onUpdateTabIndex",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    cityPickCustomeLabel(option) {
      return `${option.depcode.city} — [${option.depcode.airportcode}]`;
    },
    ///to change class of city picker
    addCssClass() {
      //
      try {
        if (BaseConfiguration.isDebug) console.log("addCssClass");

        let countryTitleLIst = document.getElementsByClassName(
          "multiselect__option--disabled"
        );
        setTimeout(() => {
          for (let index = 0; index < countryTitleLIst.length; index++) {
            const element = countryTitleLIst[index];
            element.parentNode.classList.add("active");
          }
        }, 100);
      } catch (error) {
        //ignore
      }
    },

    assignDefaultCitizen: function (pdefaultCitizen) {
      try {
        if (BaseConfiguration.isDebug) console.log("assignDefaultCitizen");

        let retCitizen = null;

        if (
          pdefaultCitizen == this.lsCitizen.CITIZEN.code ||
          pdefaultCitizen == this.lsCitizen.CANADIAN.code
        ) {
          retCitizen = cloneData(this.lsCitizenCategory[TRIP.ONE_WAY - 1]);
        } else {
          retCitizen = cloneData(this.lsCitizenCategory[TRIP.ONE_WAY]);
        }
        this.onChangedCitizen(retCitizen);

        return retCitizen;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_VIEW,
          "error in assignDefaultCitizen",
          err.toString(),
          "assignDefaultCitizen",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    assigni18nObjByLang(pFrom, pTo) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("assigni18nObjByLang");

        retValue = {
          night: this.$t("flightDatePicker.night"),
          nights: this.$t("flightDatePicker.nights"),
          "day-names": [
            this.$t("flightDatePicker.sun"),
            this.$t("flightDatePicker.mon"),
            this.$t("flightDatePicker.tue"),
            this.$t("flightDatePicker.wed"),
            this.$t("flightDatePicker.thur"),
            this.$t("flightDatePicker.fri"),
            this.$t("flightDatePicker.sat"),
          ],
          "check-in": pFrom
            ? formatDate(pFrom, "ddd, MMM DD")
            : this.$t("fareView.optional"),
          // this.$t("flightDatePicker.checkIn"),
          // "check-out":"",
          "check-out": pTo
            ? formatDate(addDays(new Date(pTo), 7), "ddd, MMM DD")
            : this.$t("fareView.to"),
          "month-names": [
            this.$t("flightDatePicker.jan"),
            this.$t("flightDatePicker.feb"),
            this.$t("flightDatePicker.mar"),
            this.$t("flightDatePicker.apr"),
            this.$t("flightDatePicker.may"),
            this.$t("flightDatePicker.jun"),
            this.$t("flightDatePicker.july"),
            this.$t("flightDatePicker.aug"),
            this.$t("flightDatePicker.sep"),
            this.$t("flightDatePicker.oct"),
            this.$t("flightDatePicker.nov"),
            this.$t("flightDatePicker.dec"),
          ],
        };
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_VIEW,
          "error in assigni18nObjByLang",
          err.toString(),
          "assigni18nObjByLang",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    emitSearchObj() {
      try {
        if (BaseConfiguration.isDebug) console.log("emitSearchObj");
        updateDataEdited(false);
        this.fareViewObj = null;
        this.fareViewList = null;
        this.isSearched = false;
        this.activeTabIndex = 0;
        this.verboseInfo = [];
        this.obBookingClass = [];
        this.ibBookingClass = [];
        this.checkAndEmitValidObj(this.search);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_VIEW,
          "error while emitting search object",
          err.toString(),
          "emitSearchObj",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async checkAndEmitValidObj(pSearchObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("checkAndEmitValidObj");

        if (this.isValidSearch(pSearchObj)) {
          this.alertValue = null;
          this.SET_FAREVIEW_SEARCH_OBJ(pSearchObj);
          let selContract;
          //  if(BaseConfiguration.isDebug) console.error(pSearchObj)

          this.tabSearchObj = cloneDeep(pSearchObj);

          if (this.GET_SELECTED_CONTRACT) {
            selContract = this.GET_SELECTED_CONTRACT.contractid;
          }
          var fareLs = [];
          //  this.fareViewObj = await this.crsFareView(pSearchObj,selContract);
          //  fareLs.push(this.toGetFareViewList(this.fareViewObj))
          //  this.fareViewList = cloneDeep(fareLs);
          this.isSearched = true;
          var n = 7;
          var searchObj = cloneDeep(pSearchObj);
          var beforeDate = 3;
          var fromdate = null;
          var todate = null;
          for (let index = beforeDate; index > 0; index--) {
            fromdate = subDays(new Date(searchObj.route[0].date), index);
            if (searchObj.route[1]) {
              todate = subDays(new Date(searchObj.route[1].date), index);
            }
            if (!isPastDate(fromdate, new Date()) && (fromdate>=new Date(searchObj.bookingDate))) {
              searchObj.route[0].date = fromdate;
              if (searchObj.route[1]) {
                searchObj.route[1].date = todate;
              }
              break;
            }
          }
          Event.$emit('isFareViewCalled',true)
          this.fareViewObj = await this.crsFareView(searchObj, selContract);
          
          fareLs.push(this.toGetFareViewList(this.fareViewObj));
          var flightObj;
          flightObj = this.GroupFlightRes(fareLs,searchObj);
          this.fareViewList = cloneDeep(flightObj);
          for (let i = 1; i < n; i++) {
            this.isLoading = true;
            searchObj.route[0].date = addDays(
              new Date(searchObj.route[0].date),
              1
            );
            if (searchObj.route[1]) {
              searchObj.route[1].date = addDays(
                new Date(searchObj.route[1].date),
                1
              );
            }
            Event.$emit('isFareViewCalled',false)
            this.fareViewObj = await this.crsFareView(searchObj, selContract);
          //  if(this.fareViewObj){
          //   this.callBookingClass(this.fareViewObj);
         
          // }
            fareLs.push(this.toGetFareViewList(this.fareViewObj));
            var flightObj;
            flightObj = this.GroupFlightRes(fareLs,searchObj);
            this.fareViewList = cloneDeep(flightObj);
          }
          let fareview = this.fareViewList;
          
          // console.log(JSON.stringify(fareview.obflights))
          for (let index = 0; index < fareview.obflights.length; index++) {
            if (fareview.obflights[index] && fareview.obflights[index].length==0) {
              this.isObflight = true;
            }else{
              this.isObflight = false;
              break;
            }
          }
          for (let j = 0; j < fareview.ibflights.length; j++) {
            if (fareview.ibflights[j] && fareview.ibflights[j].length==0) {
              this.isIbflight = true;
            } else{
              this.isIbflight = false;
              break;
            }
          }
          //  }
          this.isLoading = false;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_VIEW,
          "error in checkAndEmitValidObj",
          err.toString(),
          "checkAndEmitValidObj",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    toAssignGroupCode(pFlights, isOb) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("toAssignGroupCode");
        var flights = isOb ? pFlights.obFlight : pFlights.ibFlight;
        // flights[0]["dp"] = moment.utc(flights[0].flight.DepDate).local().format('HH:mm');
        flights[0].flight.DepDate = flights[0].flight.DepDate.substring(0, 16);
        flights[0].flight.ArrDate = flights[0].flight.ArrDate.substring(0, 16);
        let depdate = this.$options.filters.formatDate(
          flights[0].flight.DepDate,
          "DDMMMYYYYHHMM"
        );
        pFlights["pricegroup_code"] =
          flights[0].flight.FlightNo +
          flights[0].flight.opAirline +
          flights[0].flight.DepAirport +
          depdate;
        pFlights.pricegroup_code = pFlights.pricegroup_code
          .toUpperCase()
          .replace("-", "");

        retValue = pFlights;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_VIEW,
          "error in toAssignGroupCode",
          err.toString(),
          "toAssignGroupCode",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

   

    toGetBookingClass(pFareViewObj, isOb) {
      let retValue=[];
      try {
        if (BaseConfiguration.isDebug) console.log("toGetBookingClass");
        if (pFareViewObj.length != 0) {
          for (let i = 0; i < pFareViewObj.length; i++) {
            if (isOb) {
              if (
                pFareViewObj[i].obFlight &&
                pFareViewObj[i].obFlight[0] && pFareViewObj[i].obFlight[0].flight &&
                pFareViewObj[i].obFlight[0].flight.Bookingclass != "" &&
                pFareViewObj[i].obFlight[0].flight.Bookingclass != null
              ) {
                retValue.push(pFareViewObj[i].obFlight[0].flight.Bookingclass);
              }
            }
            if (!isOb) {
              if (
                pFareViewObj[i].ibFlight &&
                pFareViewObj[i].ibFlight[0] && pFareViewObj[i].ibFlight[0].flight && 
                pFareViewObj[i].ibFlight[0].flight.Bookingclass != "" &&
                pFareViewObj[i].ibFlight[0].flight.Bookingclass != null
              ) {
                retValue.push(pFareViewObj[i].ibFlight[0].flight.Bookingclass);
              }
            }
          }
          
        
        
        if (pFareViewObj[0].obFlight && isOb) {
            if (this.obBookingClass.length > retValue.length) {
              retValue = this.obBookingClass;
            }else{
              
            }
          }
          if (pFareViewObj[0].ibFlight && !isOb) {
            if (this.ibBookingClass.length > retValue.length) {
              retValue = this.ibBookingClass;
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_VIEW,
          "error in toGetBookingClass",
          err.toString(),
          "toGetBookingClass",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    toggleModal(pFlightObj,isOb) {
      let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("toggleModal");
          if(isOb){
          pFlightObj[0].obFlight[0].flight.showPaxPrice = !pFlightObj[0].obFlight[0].flight.showPaxPrice;
          }else if(!isOb){
          pFlightObj[0].ibFlight[0].flight.showPaxPrice = !pFlightObj[0].ibFlight[0].flight.showPaxPrice;
          }
          this.flights = pFlightObj
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.FARE_VIEW,
                  "error in toggleModal",
                  err.toString(),
                  "toggleModal",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
  }, 

toAddFlightObj(pFlightObj,pBookClass,isOb) {
      let retValue=[];
    let flightObj = {
    "Bookingclass": null,

    "opAirline": null,
    "mkAirline": null,
    "DepAirport": null,
    "ArrAirport": null,
    "DurationInMin": null,
    "Aircraft": null,
    "via": null,
    "cabin": null,
    "ArrDate": null,
    "DepDate": null,
    "providerID": null,
    "FlightNo": null,
    "qty": null,
    "ref": null,
  }
  let flightObject = [];
        try {
          if(BaseConfiguration.isDebug) console.log("toAddFlightObj");
          
          for (let i = 0; i < pBookClass.length; i++) {
            pFlightObj[i] = pFlightObj[0];
            flightObject.push(cloneData(flightObj));
            flightObject[i].Bookingclass = pBookClass[i];
            let flight = { flight: flightObject[i] };
            let flightsObj = cloneData(pFlightObj[i]);
            if(isOb){
              flightsObj["obFlight"]=[];
              flightsObj["obFlight"][0] = flight
          }else if(!isOb) {
             flightsObj["ibFlight"]=[];
             flightsObj["ibFlight"][0] = flight
          }
            // pFlightObj[i]["error"] = errObj.error;
            // pFlightObj[i]["pricegroup_code"] = errObj.pricegroup_code;
           retValue.push(flightsObj);
            
          }
          
    
        } catch (err) {
                let body = Logger.buildRequest(
                 COMPONENT_NAME.FARE_VIEW,
                  "error in toAddFlightObj",
                  err.toString(),
                  "toAddFlightObj",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
}, 

    toCheckForFlightResult(pFlightsObj,isOb) {
      let retValue=false;
        try {
          if(BaseConfiguration.isDebug) console.log("toCheckForFlightResult");
          if(pFlightsObj.Pricing && pFlightsObj.clientPricing){
            if(isOb && pFlightsObj.obFlight && pFlightsObj.obFlight.length!=0){
               retValue=true;
            }
            if(!isOb && pFlightsObj.ibFlight && pFlightsObj.ibFlight.length!=0){
               retValue=true;
            }
          }
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.FARE_VIEW,
                  "error in toCheckForFlightResult",
                  err.toString(),
                  "toCheckForFlightResult",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
    }, 

    GroupFlightRes(pFareLs,psearchObj) {
      let retValue = {
        ob: null,
        ib: null,
      };
      try {
        if (BaseConfiguration.isDebug) console.log("GroupFlightRes");
        var obFlights = [];
        var ibFlights = [];
        var obResults = false;
        var ibResults = false;
        if (pFareLs) {
          for (let i = 0; i < pFareLs.length; i++) {
            // if(pFareLs[i].flight_results.obflights.length==0){
            //    obResults = false;
            // }
            for (let j = 0;j < pFareLs[i].flight_results.obflights.length;j++) {
            //  obResults = this.toCheckForFlightResult(pFareLs[i].flight_results.obflights[j],true)
            //  if(obResults){
              var flights = this.toAssignGroupCode(
                pFareLs[i].flight_results.obflights[j],
                true
              );
              obFlights.push(flights);
            //  }
            }
            // if(pFareLs[i].flight_results.ibflights.length==0){
            //   ibResults = false;
            // }
            if(pFareLs[i].flight_results.ibflights.length!=0){
            for ( let k = 0; k < pFareLs[i].flight_results.ibflights.length;k++) {
              // ibResults = this.toCheckForFlightResult(pFareLs[i].flight_results.ibflights[k],false)
            //  if(ibResults){
              var flights = this.toAssignGroupCode(
                pFareLs[i].flight_results.ibflights[k],
                false
              );
              ibFlights.push(flights);
            //  }
            }
          }
            var obGrpFlights = [];
            var ibGrpFlights = [];
            if ( pFareLs[i].flight_results.verboseInfo && 
                pFareLs[i].flight_results.verboseInfo.flight_results) {
                //  if(pFareLs[i].flight_results.obflights.length<pFareLs[i].flight_results.verboseInfo.flight_results.obflights.length){
                //    obResults = false;
                //  }
                //  if(pFareLs[i].flight_results.ibflights.length<pFareLs[i].flight_results.verboseInfo.flight_results.ibflights.length){
                //    ibResults = false;
                //  }
              if ( pFareLs[i].flight_results.verboseInfo.flight_results.obflights.length != 0 &&
                pFareLs[i].flight_results.verboseInfo.flight_results.obflights[0].obFlight) {
                for (let j = 0;j <pFareLs[i].flight_results.verboseInfo.flight_results.obflights.length;j++) {
                  // for (let index = 0;index <pFareLs[i].flight_results.verboseInfo.flight_results.obflights[j].obFlight.length;index++) {
                    pFareLs[i].flight_results.verboseInfo.flight_results.obflights[j].obFlight[0].flight["showPaxPrice"] = false;
                  // }
                  var flights = this.toAssignGroupCode(pFareLs[i].flight_results.verboseInfo.flight_results.obflights[j],true);
                  flights.Pricing.invalidFares = [...new Set(flights.Pricing.invalidFares)];
                  flights.Pricing.invalidPrices = [...new Set(flights.Pricing.invalidPrices)];
                  obFlights.push(flights);
                }
              }

              if (pFareLs[i].flight_results.verboseInfo.flight_results.ibflights.length != 0 &&
                pFareLs[i].flight_results.verboseInfo.flight_results.ibflights[0].ibFlight) {
                for (let j = 0;j <pFareLs[i].flight_results.verboseInfo.flight_results.ibflights.length;j++) {
                  // for (let index = 0;index <pFareLs[i].flight_results.verboseInfo.flight_results.ibflights[j].ibFlight.length;index++) {
                    pFareLs[i].flight_results.verboseInfo.flight_results.ibflights[j].ibFlight[0].flight["showPaxPrice"] = false;
                  // }

                  var flights = this.toAssignGroupCode(pFareLs[i].flight_results.verboseInfo.flight_results.ibflights[j],false);
                  flights.Pricing.invalidFares = [...new Set(flights.Pricing.invalidFares)];
                  flights.Pricing.invalidPrices = [...new Set(flights.Pricing.invalidPrices)];
                  ibFlights.push(flights);
                }
              }

              if ( pFareLs[i].flight_results.verboseInfo.flight_results.obflights.length != 0 &&
                !pFareLs[i].flight_results.verboseInfo.flight_results.obflights[0].obFlight) {
                obFlights.push(pFareLs[i].flight_results.verboseInfo.flight_results.obflights[0]);
              }
              if ( pFareLs[i].flight_results.verboseInfo.flight_results.ibflights.length != 0 &&
                !pFareLs[i].flight_results.verboseInfo.flight_results.ibflights[0].ibFlight) {
                ibFlights.push(pFareLs[i].flight_results.verboseInfo.flight_results.ibflights[0]);
              }
              if (pFareLs[i].flight_results.verboseInfo.flight_results.obflights.length == 0) {
                let errors=[];
                errors = this.toCheckForVerboseInfo(pFareLs[i],true);
               
                 if(errors.length==0){
                  errors.push('no flights for this date');
                }
                let errObj = { error: errors };
                let obFlightObj = pFareLs[i].flight_results.verboseInfo.flight_results.obflights;
                obFlightObj[0] = errObj;
                obFlightObj[0]["pricegroup_code"] = psearchObj.route[0].date;
                obFlights.push(obFlightObj[0]);
              }
               if (psearchObj.trip==2 && pFareLs[i].flight_results.verboseInfo.flight_results.ibflights.length == 0) {
                let errors=[];
                errors = this.toCheckForVerboseInfo(pFareLs[i],true);
               
                 if(errors.length==0){
                  errors.push('no flights for this date');
                }
                let errObj = { error: errors };
                let ibFlightObj = pFareLs[i].flight_results.verboseInfo.flight_results.ibflights;
                ibFlightObj[0] = errObj;
                ibFlightObj[0]["pricegroup_code"] = psearchObj.route[1]?psearchObj.route[1].date:null;
                ibFlights.push(ibFlightObj[0]);
              }
            }
          }
          
          retValue.ob = groupBy(obFlights, "pricegroup_code");
          retValue.ib = groupBy(ibFlights, "pricegroup_code");
         
        }
        retValue = JSON.parse(JSON.stringify(retValue));
        var noObFlight=[]
        var noIbFlight=[];
        for (var index in retValue.ob) {
          
          if(!retValue.ob[index][0].obFlight){
            retValue.ob[index][0]['key'] = index;
            noObFlight.push(retValue.ob[index]);
          }
          
      }
      for (var ibIndex in retValue.ib) {
          
          if(!retValue.ib[ibIndex][0].ibFlight){
            retValue.ib[ibIndex][0]['key'] = ibIndex;
            noIbFlight.push(retValue.ib[ibIndex]);
          }
          
      }
        if(noObFlight.length!=0){
        for(var i in retValue.ob){
          if(retValue.ob[i][0].obFlight){
          var d1 = this.$options.filters.formatDate(retValue.ob[i][0].obFlight[0].flight.DepDate,
                DATE_TIME_FORMAT.DEFAULT_DATE_FORMAT);
                for (let k1=0; k1<noObFlight.length; k1++) {
                   var d2 = this.$options.filters.formatDate(noObFlight[k1][0].pricegroup_code,
                    DATE_TIME_FORMAT.DEFAULT_DATE_FORMAT);
                    if(d1==d2){
                     this.$delete(retValue.ob,noObFlight[k1][0].key);
                    }
                }
          }
        }
      }

      if(noIbFlight.length!=0){
        for(var ibInd in retValue.ib){
          if(retValue.ib[i][0].ibFlight){
          var d1 = this.$options.filters.formatDate(retValue.ib[i][0].ibFlight[0].flight.DepDate,
                DATE_TIME_FORMAT.DEFAULT_DATE_FORMAT);
                for (let ibk1=0; ibk1<noIbFlight.length; ibk1++) {
                   var d2 = this.$options.filters.formatDate(noIbFlight[ibk1][0].pricegroup_code,
                    DATE_TIME_FORMAT.DEFAULT_DATE_FORMAT);
                    if(d1==d2){
                     this.$delete(retValue.ib,noIbFlight[ibk1][0].key);
                    }
                }
          }
        }
      }
        
        var returnValue = {
          obflights: null,
          ibflights: null,
        };
        var obFlightLs = [];
        var ibFlightLs = [];
        // for (let i=0; i< retValue.ob.length; i++) {
        for (var obkey in retValue.ob) {
          let storedepDate = this.$options.filters.formatDate(
            this.GET_FAREVIEW_SEARCH_OBJ.route[0].date,
            "DDMMMYYYY"
          );
          let depDate = null;
          if (retValue.ob[obkey][0].obFlight) {
            depDate = this.$options.filters.formatDate(
              retValue.ob[obkey][0].obFlight[0].flight.DepDate,
              "DDMMMYYYY"
            );
          } else {
            depDate = this.$options.filters.formatDate(obkey, "DDMMMYYYY");
          }
          if (storedepDate == depDate) {
            retValue.ob[obkey][0]["isSearchedDate"] = true;
          }
          obFlightLs.push(retValue.ob[obkey]);
        }
      // }
        for (var ibkey in retValue.ib) {
          let storedepDate =  null;
          if(this.GET_FAREVIEW_SEARCH_OBJ.route[1]){
          storedepDate = this.$options.filters.formatDate(
            this.GET_FAREVIEW_SEARCH_OBJ.route[1].date,
            "DDMMMYYYY"
          );
          }
          let depDate = null;
          if (retValue.ib[ibkey][0].ibFlight) {
            depDate = this.$options.filters.formatDate(
              retValue.ib[ibkey][0].ibFlight[0].flight.DepDate,
              "DDMMMYYYY"
            );
          } else {
            depDate = this.$options.filters.formatDate(ibkey, "DDMMMYYYY");
          }
          if (storedepDate == depDate) {
            retValue.ib[ibkey][0]["isSearchedDate"] = true;
          }
          ibFlightLs.push(retValue.ib[ibkey]);
        }
        returnValue.obflights = obFlightLs;
        returnValue.ibflights = ibFlightLs;

        for (let m = 0; m < obFlightLs.length; m++) {
          if(obFlightLs[m][0].obFlight){
          this.obBookingClass = this.toGetBookingClass(
            obFlightLs[m],
            true
          );
          this.obBookingClass = [...new Set(this.obBookingClass)];
          }
          else{
            obFlightLs[m] = this.toAddFlightObj(obFlightLs[m],this.obBookingClass,true);
          //   this.obBookingClass = this.toGetBookingClass(
          //   obFlightLs[m],
          //   true
          // );
          }
        }
        for (let n = 0; n < ibFlightLs.length; n++) {
          if(ibFlightLs[n][0].ibFlight){
          this.ibBookingClass = this.toGetBookingClass(
            ibFlightLs[n],
            false
          );
          this.ibBookingClass = [...new Set(this.ibBookingClass)];
          }
          else{
            ibFlightLs[n] = this.toAddFlightObj(ibFlightLs[n],this.ibBookingClass,false);
          //   this.ibBookingClass = this.toGetBookingClass(
          //   ibFlightLs[n],
          //   false
          // );
          }
        }
       
          
          var obList= this.toGroupByBookingclass(returnValue.obflights,true);
          
          var obGrpLs = [];
          for (let j = 0; j < obList.length; j++) {
            obGrpLs=[]
            for (var ob in obList[j]) {
            obGrpLs.push(obList[j][ob])
            
          }

            returnValue.obflights[j] = [];
            for (let index = 0; index < obGrpLs.length; index++) {
              
               returnValue.obflights[j].push(obGrpLs[index]);
            }
           
          }
          if(returnValue.ibflights.length!=0){
          var ibList= this.toGroupByBookingclass(returnValue.ibflights,false);
          var ibGrpLs = [];
          for (let j = 0; j < ibList.length; j++) {
            ibGrpLs=[]
            for (var ib in ibList[j]) {
            ibGrpLs.push(ibList[j][ib])
            
          }

            returnValue.ibflights[j] = [];
            for (let index = 0; index < ibGrpLs.length; index++) {
              
               returnValue.ibflights[j].push(ibGrpLs[index]);
            }
           
          }
          }
        
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_VIEW,
          "error in GroupFlightRes",
          err.toString(),
          "GroupFlightRes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

   toGroupByBookingclass(pFlights,isOb) {
      let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("toGroupByBookingclass");
           var obLs = []
         for (var i in pFlights) {
           for (let index = 0; index < pFlights[i].length; index++) {
             if(isOb){
             pFlights[i][index]['Bookingclass'] = pFlights[i][index].obFlight[0].flight.Bookingclass;
             }
             else if(!isOb){
               pFlights[i][index]['Bookingclass'] = pFlights[i][index].ibFlight[0].flight.Bookingclass;
             }
           }
           
             obLs.push(groupBy(pFlights[i], "Bookingclass"));
          }
          retValue = JSON.parse(JSON.stringify(obLs));
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.FARE_VIEW,
                  "error in toGroupByBookingclass",
                  err.toString(),
                  "toGroupByBookingclass",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
  }, 

    toGetFareViewList(pFareViewObj) {
      var obFlights = [];
      var ibFlights = [];
      if (
        pFareViewObj.flight_results &&
        pFareViewObj.flight_results.obflights &&
        pFareViewObj.flight_results.obflights.length != 0
      ) {
        pFareViewObj = this.toGroupFlights(pFareViewObj, true);
      }
      if (
        pFareViewObj.flight_results &&
        pFareViewObj.flight_results.ibflights &&
        pFareViewObj.flight_results.ibflights.length != 0
      ) {
        pFareViewObj = this.toGroupFlights(pFareViewObj, false);
      }

      return pFareViewObj;
    },

    toGetActiveTabIndex(pIndex) {
      if (pIndex == 0) {
        this.activeTabIndex = 0;
      } else if (pIndex == 1) {
        this.activeTabIndex = 1;
      }
    },

    toGetAllGropuedFlights(pFlightObj, isOb) {
      var flights = isOb
        ? pFlightObj.flight_results.obflights
        : pFlightObj.flight_results.ibflights;
      for (let i = 0; i < flights.length; i++) {
        var objFlights = isOb ? flights[i].obFlight : flights[i].ibFlight;
        flights[i]["flightNo_code"] = null;
        if (objFlights) {
          objFlights[0].flight["TotalDuration"] = 0;
          objFlights[0].flight["showPaxPrice"] = false;
          for (let j = 0; j < objFlights.length; j++) {
            if (objFlights[j].flight)
              var depdate = this.$options.filters.formatDate(
                objFlights[j].flight.DepDate,
                "DDMMMYYYYHHMM"
              );
            // objFlights[j].flight["showPaxPrice"] = false;
            objFlights[j].flight.TotalDuration +=
              objFlights[j].flight.DurationInMin;
            flights[i]["flightNo_code"] =
              depdate +
              objFlights[j].flight.DepDate +
              objFlights[j].flight.DepAirport +
              objFlights[j].flight.FlightNo;
          }
        }
        flights[i].flightNo_code = flights[i].flightNo_code
          .toUpperCase()
          .replace("-", "");
      }
      flights = groupBy(flights, "flightNo_code");
      return pFlightObj;
    },

    toGroupFlights(pFareViewObj, isOb) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("toGroupFlights");
        if (pFareViewObj) {
          // var flight = isOb ? pFareViewObj.flight_results.obflights:pFareViewObj.flight_results.ibflights;
          pFareViewObj = this.toGetAllGropuedFlights(pFareViewObj, isOb);

          // pFareViewObj = JSON.parse(JSON.stringify(pFareViewObj));
          // let obFlights = {};
          // let k=0;
          // for(var index in pFareViewObj) {
          //   obFlights[k] = pFareViewObj[index];
          //   k++;
          // }
          // pFareViewObj = obFlights;
          retValue = pFareViewObj;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_VIEW,
          "error in toGroupFlights",
          err.toString(),
          "toGroupFlights",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    ///to get currency service url
    getOrgCurrencyServiceURL() {
      try {
        if (BaseConfiguration.isDebug) console.log("getCurrencyServiceURL");
        return SERVICE_URL.GET_ORG_CURRENCY;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_VIEW,
          "error while getting currency  service url",
          err.toString(),
          "getCurrencyServiceURL",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    ///to change currency
    onCurrencyChange(selCurrencyObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("onCurrencyChange");

        this.search.currency = selCurrencyObj;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_VIEW,
          "error while changing currency",
          err.toString(),
          "onCurrencyChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to assign route objects by trip
    assignRouteObjByTrip(pRouteObj, pValue) {
      try {
        if (BaseConfiguration.isDebug) console.log("assignRouteObjByTrip");

        let lsRouteObj = [];
        //this.search.route = [];
        for (var i = 0; i < pValue; i++) {
          let obj = cloneData(pRouteObj);
          if (i == 1) {
            obj.date = addDays(new Date(lsRouteObj[0].date), 7);
            // obj.date = new Date(
            //   new Date().setDate(new Date(lsRouteObj[0].date).getDate() + 7)
            // );
          }
          lsRouteObj.push(obj);
        }
        // lsRouteObj[TRIP.ONE_WAY].date=new Date(new Date().setDate(new Date(lsRouteObj[0].date).getDate() + 7));
        return lsRouteObj;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_VIEW,
          "error while assigning object",
          err.toString(),
          "assignRouteObjByTrip",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    //      toggleCheckIn(){

    // this.$refs.flightDatePicker.checkIn=new Date(this.search.route[0].date);
    // this.$refs.flightDatePicker.checkOut=new Date(this.search.route[0].date);
    //      },

    ///to change trip category based on trip type
    onChangeTripCategory(pTripType) {
      try {
        if (BaseConfiguration.isDebug) console.log("onChangeTripCategory");

        let selArrivalRoute = this.search.route[0].to;
        this.search.trip = cloneData(pTripType.code);

        if (pTripType.code != TRIP.MULTI_CITY) {
          this.isMLSearch = false;
          this.isDatePicShow = false;
          this.search.trip = pTripType.code;

          var routeObj = this.search.route[TRIP.ONE_WAY - 1];

          if (this.search.trip == TRIP.MULTI_CITY) {
            ///multiple city
            //handle later
          } else {
            ///oneway or roundTrip

            this.search.route = this.assignRouteObjByTrip(
              routeObj,
              this.search.trip
            );
          }
          let that = this;
          Vue.nextTick(function () {
            that.isDatePicShow = true;
          });

          let retSearchObj = this.assignDepToSearch(this.search.route[0].from); ///to save the existing departure while certain trip change
          if (retSearchObj != null) {
            this.search.route = retSearchObj.route;
          } else {
            this.search.route = null;
          }

          if (this.search.trip == TRIP.ONE_WAY) {
            // this.search.route[0].date=new Date();
            // this.toggleCheckIn();
          } else {
            //  this.searchHistory = this.getSearchHistory(this.USER_ID);
            //   if(this.searchHistory.length>0){
            //     if(this.searchHistory[this.searchHistory.length-1].search.trip==2){
            //  this.search.route[0].date=this.searchHistory[this.searchHistory.length-1].search.route[0].date;
            //   this.search.route[1].date=this.searchHistory[this.searchHistory.length-1].search.route[1].date;
            //     }
            //   }
          }

          this.assignArrToSearch(this.search.route[0].to); ///to save the existing arrival
          // this.toggleCheckIn();
          this.getArrivalRoutes(this.search.route[0].from);
          this.search.route[0].to = selArrivalRoute;
        } else {
          this.isMLSearch = true;
           //  navigate(PATHNAME.ROUTE)
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_VIEW,
          "error while change trip category",
          err.toString(),
          "onChangeTripCategory",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to save departure country value to search object
    assignDepToSearch(depVal) {
      try {
        if (BaseConfiguration.isDebug) console.log("assignDepToSearch");

        var retSearchObj = this.search;
        if (depVal != null) {
          //if 1st selection is departure
          if (retSearchObj.trip == TRIP.ONE_WAY) {
            ///OneWay
            retSearchObj.route[TRIP.ONE_WAY - 1].from = depVal;
          } else if (retSearchObj.trip == TRIP.ROUND_TRIP) {
            //RoundTrip
            retSearchObj.route[TRIP.ONE_WAY - 1].from = depVal;
            retSearchObj.route[TRIP.ONE_WAY].to = depVal;
          } else {
            ///Multiple City -handle later
            retSearchObj.route[TRIP.ONE_WAY - 1].from = depVal;
          }
        }

        return retSearchObj;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_VIEW,
          "error while assigning departure value to search",
          err.toString(),
          "assignDepToSearch",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to assign arrival country value to search object
    assignArrToSearch(arrVal) {
      try {
        if (BaseConfiguration.isDebug) console.log("assignArrToSearch");

        var searchObj = this.search;
        if (arrVal != null) {
          if (searchObj.trip == TRIP.ONE_WAY) {
            ///oneway
            searchObj.route[TRIP.ONE_WAY - 1].to = arrVal;
          } else if (this.search.trip == TRIP.ROUND_TRIP) {
            ///roundtrip
            searchObj.route[TRIP.ONE_WAY - 1].to = arrVal;
            searchObj.route[TRIP.ONE_WAY].from = arrVal;
          } else {
            ///multiple city
            searchObj.route[TRIP.ONE_WAY - 1].to = arrVal;
          }
        } else {
          searchObj.route[TRIP.ONE_WAY - 1].to = null;
        }
        this.search.route = searchObj.route;
        // return searchObj;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_VIEW,
          "error while assigning arrival value to search",
          err.toString(),
          "assignArrToSearch",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to get departure date
    getFromDate(selectedDate) {
      try {
        if (BaseConfiguration.isDebug) console.log("getFromDate");
        this.search.route[0].date = selectedDate;

        this.isBookingDatePicShow = false;
        this.search.bookingDate=new Date();
        let that = this;
        Vue.nextTick(function () {
          that.isBookingDatePicShow = true;
        });
          //  if (this.search.trip==this.jTypeTabs[0].code && this.isBookingDatePicShow) {
          //   this.openDatePicker();
          // }
        
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_VIEW,
          "error in getFromDate ",
          err.toString(),
          "getFromDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getBookingFromDate(selectedDate) {
      try {
        if (BaseConfiguration.isDebug) console.log("getBookingFromDate");
        this.search.bookingDate = selectedDate;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_VIEW,
          "error in getBookingFromDate ",
          err.toString(),
          "getBookingFromDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    // getBookingToDate(selectedDate) {
    //   try {
    //     if (BaseConfiguration.isDebug) console.log("getBookingToDate");
    //     this.search.route[0].bookingDate = selectedDate;
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.FARE_VIEW,
    //       "error in getBookingToDate ",
    //       err.toString(),
    //       "getBookingFromDagetBookingToDatete",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    // },
    ///to get arrival date
    getToDate(selectedDate) {
      try {
        if (BaseConfiguration.isDebug) console.log("getToDate");
        if (this.search.trip == TRIP.ROUND_TRIP) {
          if (selectedDate) {
            this.search.route[1].date = selectedDate;
          } else {
            this.search.route[1].date = addDays(
              new Date(this.search.route[0].date),
              7
            );
          }
          
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_VIEW,
          "error in getToDate ",
          err.toString(),
          "getToDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to get number of routes response from api
    async crsFareView(pSearchObj, pContractId) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("crsFareView");

        let crsFareViewRequest = apiCrsFareView.buildRequest(
          pSearchObj,
          pContractId
        );

        if (crsFareViewRequest) {
          let crsFareViewResponse = await apiCrsFareView.getResponse(
            crsFareViewRequest
          );

          if (VALIDATE_SUCCESS_RES(crsFareViewResponse)) {
            retValue = crsFareViewResponse.data.data;
            this.toCheckForVerboseInfo(retValue,false);
          } else {
            let error = getErrorMessage(crsFareViewResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_VIEW,
          "error while getting response from get Routes response API",
          err.toString(),
          "getRoutesResponse",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    toCheckForVerboseInfo(pFareViewObj,isLoop) {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("toCheckForVerboseInfo");
        if(isLoop){
          this.verboseInfo=[]
        }
        if (
          pFareViewObj.flight_results &&
          pFareViewObj.flight_results.verboseInfo
        ) {
          if (
            pFareViewObj.flight_results.verboseInfo.error &&
            pFareViewObj.flight_results.verboseInfo.error.length != 0
          ) {
            for (
              let i = 0;
              i < pFareViewObj.flight_results.verboseInfo.error.length;
              i++
            ) {
              this.verboseInfo.push(
                pFareViewObj.flight_results.verboseInfo.error[i]
              );
            }
          }
          if (pFareViewObj.flight_results.verboseInfo.contract) {
            if (
              pFareViewObj.flight_results.verboseInfo.error &&
              pFareViewObj.flight_results.verboseInfo.contract.error != ""
            ) {
              this.verboseInfo.push(pFareViewObj.flight_results.contract.error);
            }
            if (
              pFareViewObj.flight_results.verboseInfo.contract.error &&
              pFareViewObj.flight_results.verboseInfo.error.length != 0
            ) {
              for (
                let i = 0;
                i < pFareViewObj.flight_results.verboseInfo.error.length;
                i++
              ) {
                this.verboseInfo.push(
                  pFareViewObj.flight_results.verboseInfo.error[i]
                );
              }
            }

            if (
              pFareViewObj.flight_results.verboseInfo.contract &&
              pFareViewObj.flight_results.verboseInfo.contract
                .invalidContract &&
              pFareViewObj.flight_results.verboseInfo.contract.invalidContract
                .length != 0
            ) {
              for (
                let i = 0;
                i <
                pFareViewObj.flight_results.verboseInfo.contract.invalidContract
                  .length;
                i++
              ) {
                this.verboseInfo.push(
                  pFareViewObj.flight_results.verboseInfo.contract
                    .invalidContract[i].error
                );
              }
            }
          }
        }
        this.verboseInfo = [...new Set(this.verboseInfo)];
        retValue = this.verboseInfo;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_VIEW,
          "error in toCheckForVerboseInfo",
          err.toString(),
          "toCheckForVerboseInfo",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    ///to get number of routes response from api
    async getRoutesResponse() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getRoutesResponse");

        let getRoutesRequest = apiGetRoutes.buildRequest();

        if (getRoutesRequest) {
          let getRouteResponse = await apiGetRoutes.getResponse(
            getRoutesRequest
          );

          if (VALIDATE_SUCCESS_RES(getRouteResponse)) {
            retValue = getRouteResponse.data.data;
            this.SET_ROUTES_OBJ(retValue);
          } else {
            let error = getErrorMessage(getRouteResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_VIEW,
          "error while getting response from get Routes response API",
          err.toString(),
          "getRoutesResponse",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    ///method to get routes for particular country
    getRoutesByCountryCode() {
      try {
        if (BaseConfiguration.isDebug) console.log("getRoutesByCountryCode");

        let countries = this.routesResponse.countries;
        let airports = this.routesResponse.airports;
        let routes = this.routesResponse.routes;
        let listOfRoutes = [];

        var routesGrpByList = GroupByList(routes, "depcode", "arrCombination"); ///list of routes grouped by depcode
        for (let i = 0; i < Object.keys(countries).length; i++) {
          for (let j = 0; j < Object.keys(airports).length; j++) {
            let lsArrCodes = [];
            if (
              Object.values(countries)[i].countrycode ==
              Object.values(airports)[j].countryid
            ) {
              for (let k = 0; k < routesGrpByList.length; k++) {
                if (
                  routesGrpByList[k].depcode ==
                  Object.values(airports)[j].airportcode
                ) {
                  for (
                    let l = 0;
                    l < routesGrpByList[k].arrCombination.length;
                    l++
                  ) {
                    lsArrCodes.push(
                      routesGrpByList[k].arrCombination[l].arrcode
                    );
                  }
                }
              }

              let lsArrCodesForDep = {
                // "routes": 1,
                depcode: Object.values(airports)[j],
                arrcode: lsArrCodes,
              }; ///list of arrival for particular departure

              listOfRoutes.push(lsArrCodesForDep); ///list of routes for particular country
            }
          }

          let countryRoute = {
            country: Object.values(countries)[i],
            routeList: listOfRoutes,
          };
          listOfRoutes = [];
          this.lsCountryRoute.push(countryRoute);
        }
        let startCountry = cloneData(this.lsCountryRoute[0]);
        for (let index = 0; index < this.lsCountryRoute.length; index++) {
          const countryObj = this.lsCountryRoute[index];
          if (
            countryObj.country.countrycode ==
            BaseConfiguration.defaultCountryValue
          ) {
            this.lsCountryRoute[0] = countryObj;
            this.lsCountryRoute[index] = startCountry;
            break;
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_VIEW,
          "error while formatting routes",
          err.toString(),
          "getRoutesByCountryCode",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to get list of arrival routes
    getArrivalRoutes(pValue) {
      try {
        if (BaseConfiguration.isDebug) console.log("getArrivalRoutes");

        let lsOfRouteArrival = [];
        if (this.routesResponse != null) {
          let countries = this.routesResponse.countries;
          let airports = this.routesResponse.airports;
          let listOfRoutes = [];
          var airGrpByList = GroupByList(
            airports,
            "countryid",
            "arrCombination"
          ); ///list of routes grouped by depcode

          if (pValue && pValue.arrcode.length > 0) {
            if (this.lsArrival.length > 0) {
              this.lsArrival = []; //to clear the list
            }

            for (let i = 0; i < airGrpByList.length; i++) {
              listOfRoutes = [];
              for (let j = 0; j < pValue.arrcode.length; j++) {
                if (
                  airGrpByList[i].countryid ==
                  airports[pValue.arrcode[j]].countryid
                ) {
                  let lsArrCodesForDep = {
                    depcode: airports[pValue.arrcode[j]],
                    arrcode: [],
                  };
                  listOfRoutes.push(lsArrCodesForDep);
                }
              }
              if (listOfRoutes.length > 0) {
                let countryRoute = {
                  country: countries[airGrpByList[i].countryid],
                  routeList: listOfRoutes,
                };
                lsOfRouteArrival.push(countryRoute);
              }
            }

            this.lsArrival = lsOfRouteArrival;

            this.SET_ARR_LS(this.lsArrival);
            this.search.route[0].to = null;

            let retSearchObj = this.assignDepToSearch(
              this.search.route[0].from
            );
            if (retSearchObj != null) {
              this.search.route = retSearchObj.route;
            } else {
              this.search.route = null;
            }

            this.assignArrToSearch(this.search.route[0].to);
          } else {
            this.getRoutesByCountryCode();
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_VIEW,
          "error while formatting routes",
          err.toString(),
          "getArrivalRoutes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    // to validate search
    isValidSearch(pSearch) {
      if (BaseConfiguration.isDebug) console.log("isValidSearch");
      try {
        let retValue = false;
        if (pSearch.trip == TRIP.ONE_WAY) {
          if (pSearch.route && pSearch.route.length == TRIP.ONE_WAY) {
            if (
              pSearch.route[TRIP.ONE_WAY - 1].from != null &&
              pSearch.route[TRIP.ONE_WAY - 1].to != null &&
              pSearch.route[TRIP.ONE_WAY - 1].from.depcode.airportcode !==
                pSearch.route[TRIP.ONE_WAY - 1].to.depcode.airportcode
            ) {
              if (
                getDiffBtwDates(
                  new Date(pSearch.route[TRIP.ONE_WAY - 1].date),
                  new Date(),
                  "days"
                ) >= 0
              ) {
                 if (
                  new Date(pSearch.route[TRIP.ONE_WAY - 1].date)>=
                  new Date(pSearch.bookingDate)
              ) {
                if (this.currencyValidation(pSearch)) {
                  retValue = true;
                } else {
                  retValue = false;
                  this.showAlertMessage(this.$t("searchPage.selectCurrency"));
                }
              } else {
                retValue = false;
                this.showAlertMessage('Invalid Booking Date');
              }
              }
             else {
                retValue = false;
                this.showAlertMessage(this.$t("searchPage.dateInvalid"));
              }
            } else {
              retValue = false;
              this.showAlertMessage(this.$t("searchPage.routeInvalid"));
            }
          } else {
            retValue = false;
            this.showAlertMessage(this.$t("searchPage.routeLengthInvalid"));
          }
        } else if (pSearch.trip == TRIP.ROUND_TRIP) {
          if (pSearch.route && pSearch.route.length == TRIP.ROUND_TRIP) {
            if (
              pSearch.route[TRIP.ROUND_TRIP - 2].from != null &&
              pSearch.route[TRIP.ROUND_TRIP - 2].to != null &&
              pSearch.route[TRIP.ROUND_TRIP - 2].from.depcode.airportcode !==
                pSearch.route[TRIP.ROUND_TRIP - 2].to.depcode.airportcode
            ) {
              if (
                pSearch.route[TRIP.ROUND_TRIP - 1].from != null &&
                pSearch.route[TRIP.ROUND_TRIP - 1].to != null &&
                pSearch.route[TRIP.ROUND_TRIP - 1].from.depcode.airportcode !==
                  pSearch.route[TRIP.ROUND_TRIP - 1].to.depcode.airportcode
              ) {
                if (
                  getDiffBtwDates(
                    new Date(pSearch.route[TRIP.ROUND_TRIP - 1].date),
                    new Date(pSearch.route[TRIP.ROUND_TRIP - 2].date),
                    "days"
                  ) >= 0
                ) {
                  if (
                    new Date(pSearch.route[TRIP.ROUND_TRIP - 1].date)>=
                    new Date(pSearch.bookingDate)
                  
                ) {
                  if (this.currencyValidation(pSearch)) {
                    retValue = true;
                  } else {
                    retValue = false;
                    this.showAlertMessage(this.$t("searchPage.selectCurrency"));
                  }
                } else {
                  retValue = false;
                  this.showAlertMessage('Invalid Booking Date');
                }
              }else {
                  retValue = false;
                  this.showAlertMessage(
                    this.$t("searchPage.returnDateInvalid")
                  );
                }
              } else {
                retValue = false;
                this.showAlertMessage(this.$t("searchPage.routeInvalid"));
              }
            } else {
              retValue = false;
              this.showAlertMessage(this.$t("searchPage.routeInvalid"));
            }
          } else {
            retValue = false;
            this.showAlertMessage(this.$t("searchPage.routeLengthInvalid"));
          }
        } else {
          retValue = false;
          this.showAlertMessage(this.$t("searchPage.tripInvalid"));
        }
        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_VIEW,
          "error in isValidSearch",
          err.toString(),
          "isValidSearch",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to validate a currency(if currency slected or not)
    currencyValidation(pSearch) {
      try {
        if (BaseConfiguration.isDebug) console.log("currencyValidation");

        let retValue;
        if (pSearch.currency) {
          if (pSearch.currency.currency_code) {
            if (pSearch.currency.currency_code.code) {
              retValue = true;
            } else {
              retValue = false;
            }
          } else {
            retValue = false;
          }
        } else {
          retValue = false;
        }
        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_VIEW,
          "error in currencyValidation",
          err.toString(),
          "currencyValidation",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    // to show alert message
    showAlertMessage(value) {
      try {
        if (BaseConfiguration.isDebug) console.log("showAlertMessage");
        if (value) {
          // this.showAlert = true;
          this.alertValue = value;
          this.currentAlertCounter = BaseConfiguration.defaultAlertCounter;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_VIEW,
          "error in showAlertMessage",
          err.toString(),
          "showAlertMessage",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    rotate() {
      if (BaseConfiguration.isDebug) console.log("rotate");

      this.toggleFlIcon();
      this.search = this.swapCity(this.search);
    },

    toggleFlIcon() {
      this.isFlIconRotate = !this.isFlIconRotate;
    },

    swapCity(pSearch) {
      let searchObj = pSearch;
      try {
        if (BaseConfiguration.isDebug) console.log("swapCity");
        // let retValue;
        if (searchObj && searchObj.route[0].from && searchObj.route[0].to) {
          let toPlace = cloneData(searchObj.route[0].from);
          let fromPlace = pSearch.route[0].to;
          depListIndex: for (
            let index = 0;
            index < this.lsCountryRoute.length;
            index++
          ) {
            const depList = this.lsCountryRoute[index].routeList;
            depIndex: for (let index = 0; index < depList.length; index++) {
              const dep = depList[index];
              if (dep.depcode.airportcode == fromPlace.depcode.airportcode) {
                searchObj.route[0].from = dep;
                this.getArrivalRoutes(searchObj.route[0].from);
                break depListIndex;
              }
            }
          }
          // let toPlace=pSearch.route[0].to;
          for (let index = 0; index < this.lsArrival.length; index++) {
            const arrList = this.lsArrival[index].routeList;
            for (let index = 0; index < arrList.length; index++) {
              const arr = arrList[index];
              if (arr.depcode.airportcode == toPlace.depcode.airportcode) {
                searchObj.route[0].to = arr;
                this.assignArrToSearch(searchObj.route[0].to);
              }
            }
          }
        } else {
          this.toggleFlIcon();
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_SEARCH,
          "error in swapCity",
          err.toString(),
          "swapCity",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return searchObj;
    },
  },

  computed: {
    DATE_TIME_FORMAT() {
      return DATE_TIME_FORMAT;
    },
    ...mapGetters("sContract", {
      GET_SELECTED_CONTRACT: "GET_SELECTED_CONTRACT",
    }),

    ...mapGetters("sCSearch", {}),

    ...mapGetters("sFareView", {
      routeObj: "GET_ROUTES_OBJ",
      GET_FAREVIEW_SEARCH_OBJ: "GET_FAREVIEW_SEARCH_OBJ",
      arrStoreLs: "GET_ARR_LS",
    }),
    ...mapGetters("sCOrgCurrencyDp", {
      currencyOptions: "GET_CURRENCY_OPTIONS",
    }),
    ...mapGetters("sCurrencyLs", {
      GET_ORG_CURRENCY_RES: "GET_ORG_CURRENCY_RES",
    }),

    ...mapGetters("sDashBoard", {
      USER_ID: "GET_USER_ID",
    }),
  },
  async created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");

      this.defaultCurrencyCode =
        BaseConfiguration.defaultCitizen == this.lsCitizenCategory[0].code
          ? BaseConfiguration.defaultCurrencyObj.code
          : BaseConfiguration.defaultForeignCurrencyCode;
      //  this.SET_FAREVIEW_SEARCH_OBJ(null)
      if (this.GET_FAREVIEW_SEARCH_OBJ != null) {
        this.search = this.GET_FAREVIEW_SEARCH_OBJ;
      } else {
        if (BaseConfiguration.defaultTrip == TRIP.ROUND_TRIP) {
          ///if round trip
          let pRouteObj = this.search.route[TRIP.ONE_WAY - 1];
          let obj = cloneData(pRouteObj);
          obj.date = addDays(new Date(obj.date), 7);
          // obj.bookingDate = null;

          this.search.route.push(obj);
        }
      }

      if (this.routeObj != null) {
        this.routesResponse = this.routeObj;
      } else {
        this.routesResponse = await this.getRoutesResponse();
      }
      if (this.routesResponse != null) {
        this.getRoutesByCountryCode();
        if (this.arrStoreLs.length > 0) {
          this.lsArrival = this.arrStoreLs;
        } else {
          if (this.search && this.search.route && this.search.route[0].from)
            this.getArrivalRoutes(this.search.route[0].from);

          if (this.searchObject && this.searchObject.route) {
            this.search.route[0].to = cloneDeep(this.searchObject.route[0].to);
          }
        }
      }
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.FARE_VIEW,
        "error while created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
  beforeCreate() {
    addClassToBody(COMPONENT_NAME.FARE_VIEW);
  },

  beforeDestroy() {
    removeClassBody();
  },
};
</script>


<style>
.loader{
  animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
    background-size: 1000px 104px;
    height: 200px;
    position: relative;
    overflow: hidden;
}

.loadercol{
  background: #FFF;
  width: 100%;
  height: 100px;
  position: absolute;
  top: 100px;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.test {
  background-color: rgb(167, 195, 218);
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #ffffff;
  background-color: #3e2ddd;
  border-color: #0f0096;
}

.radioOptions {
  padding: 5px;
}

.active {
  background-color: lightgray;
}
/* .dg-btn--cancel {
        margin-right: 22px;
        display: none
      } */
</style>
